module.exports = __webpack_public_path__ + "img/banner-vaccine.06d220ea.png";